
import BusRatesTable from './BusRatesTable';
import './smallkey.css';
import { Helmet } from 'react-helmet';
import Testimonials from './TestimonialKeyword';
import Accordion from './Accordion';

function Punetoindorecab() {



    const cardData =
    {
        keyword: 'Pune to Indore Cab',
        heading: 'Meghana Cab : Pune to Indore Cab',
        headingDescription: 'Meghana Cab offers Pune to Indore Cab services, making long-distance travel comfortable, affordable, and reliable. Whether you’re heading to Indore for business, education, or a family visit, our well-equipped cabs and professional drivers ensure a smooth and safe journey. Enjoy flexible booking options, transparent pricing, and on-time pickups, all backed by our 24/7 customer support. Book your Pune to Indore Cab with Meghana Cab and experience a stress-free ride with top-notch service from start to finish.',


        top: 'Top Places to Visit in Indore with Meghana Cab',

"topPlaces": [
  {
    "title": "Rajwada Palace",
    "description": "A magnificent seven‑storey 18th-century palace built by the Holkar dynasty, blending Maratha, Mughal, and European styles. With ornate archways, carved wooden jharokhas, and a landscaped forecourt featuring fountains and statues, it's a living heritage. Don't miss the vibrant light‑and‑sound show in the evenings that narrates its royal past."
  },
  {
    "title": "Lalbagh Palace",
    "description": "An opulent former royal residence of the Holkars, spread over 28–76 acres and modeled after Buckingham Palace. Built between 1886–1921, it boasts Italian marble floors, dazzling chandeliers, and finely detailed woodwork. Today it functions as a museum, showcasing royal furniture, paintings, and Holkar-era luxuries."
  },
  {
    "title": "Sarafa Bazaar",
    "description": "A unique marketplace that transforms from a bustling jewellery hub by day into Indore’s famed night‑time street‑food court. From spicy chaat to sweet jalebi, the culinary vibrancy here draws food lovers and photographers alike, as stainless steel stalls sparkle under lights in the after‑dark buzz."
  },
  {
    "title": "Central Museum (Indore Museum)",
    "description": "Founded in 1929, this museum houses a fascinating collection of prehistoric artifacts, sculptures, coins, arms, and ancient manuscripts. Highlights include Mughal-era cannons and stone relics with informative plaques, making it a must‑visit for history enthusiasts and curious minds."
  },
  {
    "title": "Ralamandal Wildlife Sanctuary",
    "description": "Once the royal hunting grounds of the Holkars, this 5 km² sanctuary is now a bird haven with occasional leopard, deer, blackbuck, and sambar sightings. Its ancient hunting lodge (‘shikargah’) echoes history, while a dense ‘living wall’ shields wildlife from highway noise."
  },
  {
    "title": "Kanch Mandir",
    "description": "A striking Jain temple entirely covered in glass mosaics, mirrors, and crystal panels. The reflective surfaces imbue the interiors with a kaleidoscope-like luminosity. Built in the early 20th century, its intricate workmanship and serene ambiance offer a spiritual and visual treat."
  },
  {
    "title": "Holkar Stadium",
    "description": "Named after the Holkar royal dynasty, this international stadium seats 30,000 spectators and has hosted Tests, ODIs, and IPL matches. It features modern floodlights and named galleries honoring cricket legends. A mecca for sports fans, it exudes a thrilling live-match atmosphere."
  },
  {
    "title": "Bada Ganapati & Annapurna Temple",
    "description": "Two spiritually resonant temples in central Indore—Bada Ganapati revered for its four‑armed Lord Ganesha idol, and Annapurna Temple dedicated to the goddess of food. Both artistically carved structures are alive with daily rituals and local devotion."
  },
  {
    "title": "Patalpani Waterfall",
    "description": "A scenic waterfall located ~35 km from the city on the Choral River. Plunging about 300 ft, it forms a captivating misty vista, especially during monsoons. A popular day‑trip spot—ideal for nature photography and light trekking along forested trails."
  },
  {
    "title": "Manik Bagh Palace",
    "description": "The modernist Art Deco–style palace commissioned in 1930 by Maharaja Yashwant Rao Holkar II. Designed by German architect Eckart Muthesius, its Bauhaus interiors and elegant gardens reflect a rare blend of European modernism and Indian royal taste—now serving as a government heritage site."
  }
],

"services": [
    {
        "name": "Pune to Indore Taxi Booking",
        "description": "Book a reliable taxi from Pune to Indore with Meghana Cab and enjoy a smooth, intercity journey across states. Our service features timely pickups, professional drivers, and comfortable vehicles tailored for long-distance road travel."
    },
    {
        "name": "Outstation Cab Pune to Indore",
        "description": "Travel from Pune to Indore stress-free with Meghana Cab’s outstation cab services. Our fleet is well-maintained for highway journeys, offering AC comfort, safety, and experienced drivers familiar with the entire route."
    },
    {
        "name": "Pune to Indore One Way Cab",
        "description": "Need a single-drop taxi to Indore? Meghana Cab offers affordable one-way cab options from Pune to Indore with flexible departure times, doorstep pickup, and a wide range of AC vehicles for all travel needs."
    },
    {
        "name": "Round Trip Taxi Pune to Indore",
        "description": "Planning a return journey? Meghana Cab provides round trip taxi services between Pune and Indore with fair pricing and professional drivers who stay with you throughout the trip—perfect for short stays or weekend plans."
    },
    {
        "name": "AC Cab Hire for Pune to Indore",
        "description": "Beat the heat with Meghana Cab’s air-conditioned cab hire from Pune to Indore. Whether you're traveling for business or leisure, our AC cars ensure a cool, quiet, and comfortable ride over the long distance."
    },
    {
        "name": "Budget Cab Pune to Indore",
        "description": "Looking for affordable travel options? Meghana Cab offers budget-friendly taxi services from Pune to Indore. Get clean, fuel-efficient cars with no hidden costs, ideal for personal, student, or low-cost travel."
    },
    {
        "name": "Pune to Indore by Road Taxi",
        "description": "Travel the Pune to Indore route by road in comfort and safety with Meghana Cab. Our highway-ready vehicles and drivers ensure a hassle-free ride through scenic and well-planned routes, avoiding delays and discomfort."
    },
    {
        "name": "Online Taxi for Indore Trip",
        "description": "Book your taxi to Indore online with Meghana Cab. Our easy-to-use booking platform allows you to schedule your ride instantly, compare vehicles, get upfront pricing, and pay securely—all from your mobile or desktop."
    },
    {
        "name": "Pune to Indore SUV Cabs",
        "description": "Travel in spacious comfort with Meghana Cab’s SUV taxi services from Pune to Indore. Perfect for families or group travel, our SUVs provide legroom, ample luggage space, and high performance on long-distance drives."
    },
    {
        "name": "Pune to Indore Driver Service",
        "description": "Prefer to use your own car? Meghana Cab offers professional driver services for Pune to Indore trips. Our trained drivers are punctual, route-savvy, and background-verified—letting you relax while they drive."
    },
    {
        "name": "Cab Booking Platform Pune to Indore",
        "description": "Use Meghana Cab’s dedicated cab booking platform to book your Pune to Indore taxi with ease. Enjoy real-time vehicle selection, fare transparency, and instant confirmations all in one place."
    },
    {
        "name": "Sedan Cab Pune to Indore",
        "description": "Choose a sedan cab from Pune to Indore for a smooth and refined ride. Meghana Cab’s sedans are ideal for solo travelers or couples, offering comfort, style, and fuel-efficiency for long trips."
    },
    {
        "name": "Long Route Taxi from Pune to Indore",
        "description": "Travel the long distance from Pune to Indore comfortably with Meghana Cab’s dedicated long-route taxi service. Our vehicles are built for endurance and equipped with all the amenities needed for long travel hours."
    },
    {
        "name": "Affordable Cab Fare Pune to Indore",
        "description": "Get the best rates for your Pune to Indore cab journey with Meghana Cab. Our fare estimates are accurate and transparent, ensuring no surprises—just honest pricing and professional service."
    },
    {
        "name": "Hire Car Pune to Indore",
        "description": "Hire a car from Pune to Indore with Meghana Cab and choose from hatchbacks, sedans, or SUVs. Our car hire services come with or without drivers, offering maximum flexibility and reliable support."
    }
],

"tableData": [
    ["Pune to Indore Taxi Booking", "Outstation Cab Pune to Indore"],
    ["Pune to Indore One Way Cab", "Round Trip Taxi Pune to Indore"],
    ["AC Cab Hire for Pune to Indore", "Budget Cab Pune to Indore"],
    ["Pune to Indore by Road Taxi", "Online Taxi for Indore Trip"],
    ["Pune to Indore SUV Cabs", "Pune to Indore Driver Service"],
    ["Cab Booking Platform Pune to Indore", "Sedan Cab Pune to Indore"],
    ["Long Route Taxi from Pune to Indore", "Affordable Cab Fare Pune to Indore"],
    ["Hire Car Pune to Indore", ""],
    ["", ""]
],









"whychoose": [
    {
        "WhyChooseheading": "Comfortable Pune to Indore Cab Service",
        "WhyChoosedescription": "Meghana Cab offers a comfortable and reliable cab service from Pune to Indore. Whether you’re planning a business trip, family travel, or leisure journey, enjoy a hassle-free ride in our clean and spacious vehicles."
    },
    {
        "WhyChooseheading": "Timely Pick-Up and Drop-Off",
        "WhyChoosedescription": "Punctuality is key for long-distance travel. Our Pune to Indore cab service ensures on-time pick-ups and drop-offs so you can stay on schedule, whether it’s for meetings, events, or personal travel."
    },
    {
        "WhyChooseheading": "Professional Drivers for Long-Distance Travel",
        "WhyChoosedescription": "Our drivers are skilled and experienced in handling long journeys like Pune to Indore. They prioritize your safety and comfort, and know the best routes to ensure a smooth and efficient ride."
    },
    {
        "WhyChooseheading": "Affordable Pune to Indore Cab Fare",
        "WhyChoosedescription": "Meghana Cab offers cost-effective pricing with full transparency. Our Pune to Indore cab fares are competitive, and we guarantee no hidden charges—just honest rates you can rely on."
    },
    {
        "WhyChooseheading": "Safe, Clean, and Sanitized Vehicles",
        "WhyChoosedescription": "Safety is a top priority. Our vehicles are well-maintained, thoroughly sanitized before every trip, and equipped with safety features like seat belts and GPS tracking for a secure ride."
    },
    {
        "WhyChooseheading": "24/7 Cab Availability from Pune to Indore",
        "WhyChoosedescription": "Travel whenever it suits you. Meghana Cab offers round-the-clock cab service from Pune to Indore, giving you the flexibility to book rides at your convenience—day or night."
    },
    {
        "WhyChooseheading": "Customizable Travel Plans",
        "WhyChoosedescription": "We understand that every trip is unique. That’s why we offer customizable Pune to Indore cab packages—whether you need a one-way trip, round trip, or stopovers along the route."
    },
    {
        "WhyChooseheading": "Easy Online Booking and Customer Support",
        "WhyChoosedescription": "Booking your Pune to Indore cab is simple and quick with Meghana Cab. Use our easy-to-navigate website or app, or contact our helpful support team for any booking-related assistance."
    }
]


















    }

const faqData = [
    {
        question: "How can I book a Pune to Indore cab with Meghana Cab?",
        answer: "Booking a Pune to Indore cab is easy with Meghana Cab. You can book online through our website or call us directly at +91 9075462128."
    },
    {
        question: "What cab options are available for the Pune to Indore route?",
        answer: "Meghana Cab offers hatchbacks, sedans, SUVs, and tempo travellers for the Pune to Indore journey, suitable for individuals, families, or groups."
    },
    {
        question: "Is one-way cab service available from Pune to Indore?",
        answer: "Yes, Meghana Cab provides both one-way and round-trip cab services from Pune to Indore to suit your travel plans."
    },
    {
        question: "How long does it take to travel from Pune to Indore by cab?",
        answer: "The journey from Pune to Indore typically takes around 10 to 12 hours, depending on traffic and road conditions."
    },
    {
        question: "Are tolls, parking, and taxes included in the Pune to Indore cab fare?",
        answer: "Toll charges, parking fees, and state taxes are additional and clearly communicated during the booking process."
    },
    {
        question: "Do you provide experienced drivers for Pune to Indore cabs?",
        answer: "Yes, all Meghana Cab drivers are professionally trained, experienced, and familiar with the Pune to Indore route."
    },
    {
        question: "Can I request stops during the Pune to Indore trip?",
        answer: "Yes, planned stops can be arranged. Please mention your requirements while booking so we can provide the best experience."
    },
    {
        question: "Is the Pune to Indore cab service available 24/7?",
        answer: "Absolutely. Meghana Cab operates round the clock, allowing you to book your trip at your preferred time — day or night."
    },
    {
        question: "What payment methods are accepted for Pune to Indore bookings?",
        answer: "We accept UPI, credit/debit cards, net banking, and cash for your convenience."
    },
    {
        question: "How do I contact Meghana Cab for a Pune to Indore cab booking?",
        answer: "For bookings and assistance, you can contact Meghana Cab at +91 9075462128."
    }
];

const testimonialsData = [
    {
        name: 'Mr. Prakash Jain',
        designation: 'Customer',
        rating: [1, 1, 1, 1, 1],
        text: '“Our Pune to Indore journey with Meghana Cab was extremely comfortable. The car was clean, the driver was very polite, and we reached on time. Highly recommended!”',
    },
    {
        name: 'Mrs. Sunita Bhagat',
        designation: 'Customer',
        rating: [1, 1, 1, 1, 1],
        text: '“I recently traveled from Pune to Indore with Meghana Cab. The service was top-notch — from booking to drop-off. Will surely use their service again!”',
    },
];














































    const contactData = {
        heading: `${cardData.keyword} Contact Number`,
        contactNumbers: [
            "+91 9075462128",
            "+91 8452916550",

        ],
        email: "booking@meghanacabs.com"
    };


    const Images = [
        {
            place: "/images/keyword/1.jpg",
            text: "Online Cab Booking in Pune",
        },
        {
            place: "/images/keyword/2.jpg",
            text: "Pune to Kolhapur Cab",
        },
        {
            place: "/images/keyword/3.jpg",
            text: "Pune to Satara Cab",
        },
        {
            place: "/images/keyword/4.jpg",
            text: "Pune to Hyderabad Cab",
        },
        {
            place: "/images/keyword/5.jpg",
            text: "Pune to Bangalore Cab",
        },
        {
            place: "/images/keyword/6.jpg",
            text: "Pune to Indore Cab",
        },
        {
            place: "/images/keyword/7.jpg",
            text: "Pune to Gujarat Cab",
        },

        {
            place: "/images/keyword/8.jpg",
            text: "Pune to Lonavala Taxi",
        },

        {
            place: "/images/keyword/9.jpg",
            text: "Pune to Jejuri Cab",
        },
        {
            place: "/images/keyword/10.jpg",
            text: "Local Taxi Service in Pune",
        },

        {
            place: "/images/keyword/11.jpg",
            text: "Pune to Lavasa Cab",
        },
        {
            place: "/images/keyword/12.jpg",
            text: "Pune to Kashid Beach Cab",
        },

        {
            place: "/images/keyword/13.jpg",
            text: "One Way Cab Pune",
        },

        {
            place: "/images/keyword/14.jpg",
            text: "Round Trip Cab",
        },
        {
            place: "/images/keyword/15.jpg",
            text: "Taxi Service Near Me",
        },
        {
            place: "/images/keyword/16.jpg",
            text: " Car Hire in Pune",
        },
        {
            place: "/images/keyword/17.jpg",
            text: "Seater Car on Rent in Pune",
        },
        {
            place: "/images/keyword/18.jpg",
            text: "Cab Service in Pimpri Chinchwad",
        },
        {
            place: "/images/keyword/19.jpg",
            text: "Pune Taxi Cab Services",
        },
        {
            place: "/images/keyword/20.jpg",
            text: "Pune Airport Taxi",
        },

        {
            place: "/images/keyword/21.jpg",
            text: "Pune to Rajasthan Cab",
        },
        {
            place: "/images/keyword/22.jpg",
            text: "Pune to Matheran Cab",
        },
        {
            place: "/images/keyword/23.jpg",
            text: "Pune to Pandharpur Cab",
        },
        {
            place: "/images/keyword/24.jpg",
            text: " Pune to Mumbai Cabs",
        },
        {
            place: "/images/keyword/25.jpg",
            text: "Pune to Mumbai Airport Cab ",
        },
        {
            place: "/images/keyword/26.jpg",
            text: " Pune to Mumbai Taxi",
        },
    ];


    const images = [
        { src: "/images/booking/1.jpg", alt: "Image 1" },
        { src: "/images/booking/5.jpg", alt: "Image 1" },
        { src: "/images/booking/2.jpg", alt: "Image 1" },
        { src: "/images/booking/3.jpg", alt: "Image 1" },
        { src: "/images/booking/4.jpg", alt: "Image 1" },
        { src: "/images/booking/7.jpg", alt: "Image 1" },
        { src: "/images/booking/8.jpg", alt: "Image 1" },
        { src: "/images/booking/9.jpg", alt: "Image 1" },
        { src: "/images/booking/6.jpg", alt: "Image 1" },

    ];







const productSchema = {
  "@context": "https://schema.org",
  "@type": "Product",
  "name": "Pune to Indore Cab",
  "image": "https://www.meghanacabs.com/assets/images/pune-to-indore-cab.jpg",
  "description": "Book Pune to Indore cabs with Meghana Cabs for one-way and round trips. Choose from AC, Sedan, and SUV vehicles with experienced drivers. Affordable and reliable outstation taxi service.",
  "brand": {
    "@type": "Brand",
    "name": "Meghana Cabs"
  },
  "aggregateRating": {
    "@type": "AggregateRating",
    "bestRating": "5",
    "worstRating": "1",
    "ratingValue": "4.8",
    "ratingCount": "5168"
  },
  "offers": {
    "@type": "Offer",
    "priceCurrency": "INR",
    "price": "7499",
    "availability": "https://schema.org/InStock",
    "url": "https://www.meghanacabs.com/pune-to-indore-cab"
  }
};






    return (
        <div>


<Helmet>
  <title>Pune to Indore Cab | Outstation & Round Trip Taxi | Meghana Cabs</title>
  <meta 
    name="description" 
    content="Book Pune to Indore cabs with Meghana Cabs for one-way and round trips. Choose from AC, Sedan, and SUV vehicles with experienced drivers. Affordable and reliable outstation taxi service." 
  />
  <meta 
    name="keywords" 
    content="Pune to Indore Taxi Booking, Outstation Cab Pune to Indore, Pune to Indore One Way Cab, Round Trip Taxi Pune to Indore, AC Cab Hire for Pune to Indore, Budget Cab Pune to Indore, Pune to Indore by Road Taxi, Online Taxi for Indore Trip, Pune to Indore SUV Cabs, Pune to Indore Driver Service, Cab Booking Platform Pune to Indore, Sedan Cab Pune to Indore, Long Route Taxi from Pune to Indore, Affordable Cab Fare Pune to Indore, Hire Car Pune to Indore" 
  />
  <script type="application/ld+json">
    {JSON.stringify(productSchema)}
  </script>
</Helmet>

            <section className="page-title centred">
                <div className="bg-layer" style={{ backgroundImage: 'url(/images/page-header-bg.jpg)' }}></div>
                <div className="auto-container">
                    <div className="content-box">

                        <h1>{cardData.keyword}</h1>
                    </div>
                </div>
            </section>




            <section>
                <div className="container-fluid" >
                    <div className="row ">
                        <div className="col-12 col-md-7 ">
                            <img src='/images/keyword/6.jpg' alt='img' />
                            <h3 className="py-1"
                                style={{
                                    color: '#F2614C', // Red color for the title 
                                    textShadow: '5px 5px 10px rgba(255, 255, 255, 0.7)', // Light shadow effect
                                    fontWeight: 'bold'
                                }}


                            >{cardData.heading} </h3><p className='fw-bold '>{cardData.headingDescription}</p>
                            <div className="">
                                <p className='fw-bold py-3 darkcolorrr'>{cardData.top}</p>
                                {cardData.topPlaces.map((place, index) => (
                                    <div key={index} className="">
                                        <div
                                            style={{
                                                cursor: 'pointer',
                                                padding: '10px',
                                                marginBottom: '7px',
                                                borderRadius: '8px',
                                                transition: 'transform 0.2s'
                                            }}

                                        >
                                            <h4 className="mb-1 darkcolorrr">{place.title}</h4>
                                            <p className="mb-0">{place.description}</p>
                                        </div>
                                    </div>
                                ))}
                            </div>
                            <div
                                style={{
                                    cursor: 'pointer',
                                    padding: '10px',
                                    marginBottom: '7px',
                                    borderRadius: '8px', // Optional: rounded corners
                                    transition: 'transform 0.2s' // Optional: smooth scaling effect
                                }}
                            >
                                {cardData.services.map((service, index) => (
                                    <div key={index} className=" my-4">
                                        <h4 className="py-1 darkcolorrr">{service.name}</h4>
                                        <p>{service.description}</p>
                                    </div>
                                ))}
                            </div>

                            <table className="table table-responsive Border-key my-2">
                                <tbody className=' Border-key'>
                                    {cardData.tableData.map((row, rowIndex) => (
                                        <tr className='Border-key ' key={rowIndex}>
                                            {row.map((cell, cellIndex) => (
                                                <td key={cellIndex} className=' Border-key bluecolor fw-bold' >{cell}</td>
                                            ))}
                                        </tr>
                                    ))}
                                </tbody>
                            </table>
                             <h3 className='pt-md-3 text-dark'>{cardData.keyword + " Rates"}</h3>
                            <BusRatesTable />

                            <div id="why-choose-section"
                                className='px-2'>
                                <h2 className='whycolor py-3'>Why Choose us for  {cardData.keyword}</h2>
                                {cardData.whychoose.map((item, index) => (
                                    <div key={index}>
                                        <h4 className="py-1 whycolor">{item.WhyChooseheading}</h4>
                                        <p>{item.WhyChoosedescription}</p>
                                    </div>
                                ))}
                            </div>


                            <div className="row twm-faq-section-1 m-b30">


                                <div className=" col-md-12 wow fadeInDown" data-wow-delay="0.2">
                                    <div className="twm-faq-info-wrap">

                                        <div className="section-head left">
                                            <h2 className="twm-large-title site-text-dark darkcolor">FAQS {cardData.keyword} For Meghana Cabs </h2>
                                        </div>


                                        <div className="twm-faq-info">
                                            <div className="accordion twm-acdn" id="sf-faq-accordion">
                                                <Accordion data={faqData} />
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>

                            <Testimonials testimonials={testimonialsData} />


                            <div className='py-4'>

                                <div className="contact-box Borderr">
                                    <h3 className=' text-dark'>{contactData.heading}</h3>
                                    <p className='text-black'>For booking inquiries or any assistance, please feel free to contact us:</p>
                                    <div className="contact-details">
                                        <p><strong className='darkcolor'>Mobile No:</strong></p>
                                        <ul>
                                            {contactData.contactNumbers.map((number, index) => (
                                                <li key={index}>
                                                    <a href={`tel:${number}`} className="contact-link fw-bold fs-5">
                                                        {number}
                                                    </a>
                                                </li>
                                            ))}
                                        </ul>
                                        <p><strong className='darkcolor'>Email Id: </strong>
                                            <a href={`mailto:${contactData.email}`} className="contact-link">
                                                {contactData.email}
                                            </a>
                                        </p>
                                    </div>
                                </div>
                            </div>
                        </div>

                        <div className='col-12 col-md-4' >
                            {Images.map((e) => {
                                return (
                                    <div className="box1">
                                        <a
                                            href="./"
                                            className="d-flex justify-content-around align-items-center"
                                        >
                                            <div className="b1">
                                                <img src={e.place} alt="img" />
                                            </div>
                                            <div className="b2">
                                                {" "}
                                                <a href="./" className='px-3'>{e.text}</a>
                                            </div>
                                        </a>
                                    </div>
                                );
                            })}


                            <div className="gallery-container">
                                <h2 className="gallery-title">Our Fleets</h2>
                                <div className="gallery-row d-flex flex-wrap">
                                    {images.map((image, index) => (
                                        <div className="gallery-item col-md-4" key={index}>
                                            <img
                                                src={image.src}
                                                alt={image.alt}
                                                className="gallery-image"

                                            />
                                        </div>
                                    ))}

                                </div>
                            </div>

                            <div className=" rounded p-4 shadow-sm Uni_border "
                                style={{
                                    cursor: 'pointer',
                                    padding: '10px',
                                    border: '3px dotted #F1604F',
                                    marginBottom: '7px',
                                    fontWeight: 'bold',
                                }}

                            >
                                <h4 className="pb-3 pt-3 lead fw-bold text-dark">Contact Information</h4>

                                <div className="row">

                                    <div className="col-12 mb-3">
                                        <div className="Small_border  rounded text-center py-2 " style={{ backgroundColor: '#F1604F' }}>
                                            <h4 className=" lead fw-semibold whitt text-darkk">Phone Numbers</h4>
                                            <i className="bi bi-telephone-fill fs-1 mb-2"></i>
                                            <div className=''>
                                                <a href="tel:+919075462128" className="d-block  text-white">+91 9075462128</a>
                                                <a href="tel:+918452916550" className="d-block  text-white">+91 8452916550</a>



                                            </div>
                                        </div>
                                    </div>


                                    <div className="col-12 mb-3 ">
                                        <div className="Small_border rounded text-center">
                                            <i className="bi bi-envelope fs-1 mb-2"></i>
                                            <div className='rounded py-2' style={{ backgroundColor: '#F1604F' }}>
                                                <h4 className=" fw-semibold lead whitt text-darkk">Email</h4>
                                                <a href="mailto:booking@meghanacabs.com" className=" text-white d-block">
                                                    booking@meghanacabs.com
                                                </a>
                                            </div>
                                        </div>
                                    </div>


                                    <div className="col-12 mb-3 ">
                                        <div className="Small_border  rounded text-center">
                                            <i className="bi bi-house-fill fs-1 mb-2"></i>
                                            <div className='rounded py-2' style={{ backgroundColor: '#F1604F' }}>
                                                <h4 className=" fw-semibold lead whitt text-darkk">Address</h4>
                                                <p className="whit text-white ">
                                                    <i> Meghana Cab  <br />
                                                        Yelwande Wasti. Opp Vithal Lawans, Laxmi Chowk, Hinjawadi, Pune - 411057
                                                    </i>
                                                </p>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>



                        </div>
                    </div>
                </div>
            </section>



        </div>
    );
}

export default Punetoindorecab;